/**
 * المفتاح العامّ لـVAPID — آمن للنشر في الكلاينت (هذا هو الغرض منه).
 * نظيره الخاصّ (`VAPID_PRIVATE_KEY`) يعيش كسرّ على السيرفر فقط.
 */
export const VAPID_PUBLIC_KEY =
  "BE9bKAIRpJsGe4weDMMaYEe5UjxYgbapAzDOpTrLZBWF4I3PCyYNsnG_Ne5z-RBF84UHUJ_QnCBMkH4_tt-Px1s";

/** يحوّل base64url إلى Uint8Array (مطلوب لـPushManager.subscribe). */
export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
  return output;
}
